import React from 'react';

import SuccessScreen from 'shared/components/SuccessScreen';

const Step9Success: React.FC = () => <SuccessScreen />;

export default Step9Success;
